import React, { useEffect, useState } from "react";
import { RadioButton } from "../shared/RadioButton";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router";
import Reports from "./Reports";
import { GuestManagement } from "./GuestManagement";
import Menu from "./Menu/Menu";
import PromotionalEmail from "./PromotionalEmail";
import { useSelector } from "react-redux";

const coolAlertTabs = [
    { label: 'Menu', value: 'menu' },
    // { label: 'Promotional Email', value: 'promotional-email' },
    { label: 'Guest Management', value: 'guest-management' },
    { label: 'Reports', value: 'reports' }
]

const CoolAlerts = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [currentTab, setCurrentTab] = useState('menu');
    const { storage } = useSelector((state) => state);

    useEffect(() => {
        if (pathname)
            setCurrentTab(pathname.split('/').at(-1));
    }, [pathname]);

    const handleTabSelection = (value) => {
        navigate(`/cool-alerts/${value}`)
    }

    return (
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4 mt-16">
            <h1 className="text-xl font-display font-medium leading-tight text-secondary mb-4">
                Cool Alerts
            </h1>
            {coolAlertTabs.map(({ label, value }, i) => (
                <RadioButton
                    key={i} label={label} type={value}
                    style={(value === "promotional-email") ? { display: !storage?.store?.isPromotionalEmailEnable && 'none' } : {}}
                    isSelected={currentTab === value} onClick={() => handleTabSelection(value)} />
            ))}
            <div className="w-full pt-4">
                <Routes>
                    <Route path="menu" element={<Menu />} key={'menu'} index />
                    {/* {storage?.store?.isPromotionalEmailEnable && <Route path="promotional-email" element={<PromotionalEmail />} />} */}
                    <Route path="guest-management" element={<GuestManagement />} />
                    <Route path="reports" element={<Reports />} />
                    <Route path="*" element={<Navigate to="/cool-alerts/menu" />} />
                </Routes>
            </div>
        </div>
    )
}

export default CoolAlerts;